module.exports = __webpack_public_path__ + "img/order_dispatch.cfd7d4bc.png";